export default __webpack_public_path__ + "f2a0933406f7830651524f477ba2f543.woff";